import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('riseAiGifting'),
  titleToId: true,
  titleToNamespace: true,
  avatarPath: avatars.riseAi,
  logoPath: logos.riseAi,
  hasConnectionStatus: false
});
